// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__bp36-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3jj2T"};